import { UserAccountType } from "@wingspanhq/users/dist/lib/interfaces";
import { INewUser } from "@wingspanhq/users/dist/lib/interfaces/newUser";

export const selectorIsEnterpriseUser = (user: INewUser) =>
  user.settings?.userAccountType === UserAccountType.enterprise;
